import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyReloadIcon } from './img/reload.svg'

type ReloadIconProps = IconWrapperProps

export const ReloadIcon: FC<ReloadIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyReloadIcon />
    </IconWrapper>
  )
}
